export default __webpack_public_path__ + "static/media/31.1b6e4440.webp";